/*
  QURANI · Medición del cross-sell "Complementa tu pedido" (oct-2026).
  Solo mide; no cambia qué se recomienda ni cómo se agrega.
  Eventos de Microsoft Clarity (sin datos personales):
    - cs_impresion     → la tarjeta estuvo visible (≥50 %) en pantalla. 1 vez por producto y sesión.
    - cs_clic_agregar  → clic en AGREGAR. 1 vez por producto y sesión.
    - cs_agregado      → Shopify confirmó la línea en el carrito con _Origen = cross-sell. 1 vez por variante y sesión.
  Etiquetas (clarity set): cs_visto, cs_clic, cs_agregado = handle del producto recomendado.
  La compra y los ingresos se miden en Shopify con la propiedad de línea _Origen: cross-sell.
*/
(function () {
  if (window.__qtCsTrack) return;
  window.__qtCsTrack = true;

  var SS = 'qt_cs_track';
  var mem = {};
  function seen(k) {
    try { var d = JSON.parse(sessionStorage.getItem(SS) || '{}'); if (d[k]) return true; d[k] = 1; sessionStorage.setItem(SS, JSON.stringify(d)); return false; }
    catch (e) { if (mem[k]) return true; mem[k] = 1; return false; }
  }
  function send(ev, tag, handle) {
    try {
      // Se lee window.clarity en cada envío: si Clarity aún no cargó, se usa su propia cola estándar (.q).
      if (typeof window.clarity !== 'function') window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('event', ev);
      if (handle) window.clarity('set', tag, String(handle));
    } catch (e) {}
  }

  // 1) Impresión visible
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting || en.intersectionRatio < 0.5) return;
      var el = en.target, h = el.getAttribute('data-qt-cs-handle') || '';
      io.unobserve(el);
      if (!seen('imp:' + h)) send('cs_impresion', 'cs_visto', h);
    });
  }, { threshold: [0.5] }) : null;

  function watch(root) {
    if (!io || !root || !root.querySelectorAll) return;
    var list = root.matches && root.matches('[data-qt-crosssell]') ? [root] : root.querySelectorAll('[data-qt-crosssell]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].__qtCsObs) { list[i].__qtCsObs = true; io.observe(list[i]); }
    }
  }
  function start() {
    watch(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) if (a[j].nodeType === 1) watch(a[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // 2) Clic en AGREGAR + 3) adición confirmada por Shopify
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-qt-crosssell] .qt-cs__btn') : null;
    if (!btn) return;
    var box = btn.closest('[data-qt-crosssell]');
    var h = (box && box.getAttribute('data-qt-cs-handle')) || btn.getAttribute('data-handle') || '';
    var form = btn.closest('form');
    var idEl = form && (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]'));
    var vid = idEl ? String(idEl.value) : '';
    if (!seen('clk:' + h)) send('cs_clic_agregar', 'cs_clic', h);
    if (!vid) return;
    var tries = 0;
    (function check() {
      tries++;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ok = (cart.items || []).some(function (it) {
            return String(it.variant_id) === vid && it.properties && it.properties._Origen === 'cross-sell';
          });
          if (ok) { if (!seen('add:' + vid)) send('cs_agregado', 'cs_agregado', h); }
          else if (tries < 6) setTimeout(check, 1000);
        })
        .catch(function () { if (tries < 6) setTimeout(check, 1000); });
    })();
  }, true);
})();
